module.exports = __webpack_public_path__ + "img/logo-appstore.34df68e9.png";